import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {TemplateSchema} from '../../../../api/DBSchema/Template';
import {isUserAdminSelector} from '../../../../store/selectors/user.selectors';

const pageSchema = PortalSettingsGetSchema.pages.notificationUsers;
const pageId = pageSchema.pageId;

function PortalSettingsUserNotifications({
    portalSettingsObject,
    setPortalSettingsData,
    isUserAdmin
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];
    const setPageValue = useCallback((param, newValue) => {
        setPortalSettingsData([pageId, param], newValue)
    }, [setPortalSettingsData]);

    const userAddedOrChanged = pageData[pageSchema.userAddedOrChanged];
    const userAddedOrChangedEnabled = userAddedOrChanged[TemplateSchema.enabled];

    const [isUserCreationTemplateEditorOpen, setIsUserCreationTemplateEditorOpen] = useState(false);

    return (
        <EditorLayout>
            {/* Notify user */}
            <RowLayout>
                <span style={{ width: 480 }}>
                    <SMCCheckbox
                        checked={userAddedOrChangedEnabled}
                        onChange={e => setPortalSettingsData([pageId, pageSchema.userAddedOrChanged, TemplateSchema.enabled], e.target.checked)}
                        label={t('SMC_SETTINGS_NOTIFY_USER_ADDCHANGE')}
                        inline
                    />
                </span>
                <SMCButton onClick={() => setIsUserCreationTemplateEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            {/* Popup windows */}
            {/* Notify user editor */}
            <TemplateEditorModal
                isOpen={isUserCreationTemplateEditorOpen}
                onRequestClose={() => setIsUserCreationTemplateEditorOpen(false)}
                defaultObject={userAddedOrChanged}
                onSuccess={newVal => {
                    setPageValue(pageSchema.userAddedOrChanged, newVal);
                    setIsUserCreationTemplateEditorOpen(false);
                }}
                templateName="useraddedorchanged"
                hasAdministratorsTab={isUserAdmin}
            />
        </EditorLayout>
    )
}

const mapStateToProps = state => ({
    isUserAdmin: isUserAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PortalSettingsUserNotifications);